import { Component, Input, OnInit } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'cap-rubrik',
  templateUrl: './rubrik.component.html',
  styleUrls: ['./rubrik.component.scss'],
  imports: [NgClass, NgTemplateOutlet]
})
export class RubrikComponent implements OnInit {
  @Input()
  public id: string;
  @Input()
  public isOpen: boolean;
  @Input()
  public isClosable: boolean;

  angleClass;

  constructor() {
    keysToTranslate<string>(['Aufklappen', 'Zuklappen']);
  }

  ngOnInit(): void {
    this.setAngleClass();
    if (!this.isOpen && !this.isClosable) {
      this.isOpen = true;
    }
  }

  protected toggle() {
    this.isOpen = !this.isOpen;
    this.setAngleClass();
  }

  private setAngleClass() {
    if (this.isOpen) {
      this.angleClass = 'fas fa-angle-up';
    } else {
      this.angleClass = 'fas fa-angle-down';
    }
  }
}
